import getEnv from './getEnv'

const urls = {
  local: `https://urhcx21u5a.execute-api.us-east-1.amazonaws.com/production`,
  // local: 'https://api2.orionx.io',
  dev: 'https://api2.orionx.io',
  prod: 'https://urhcx21u5a.execute-api.us-east-1.amazonaws.com/production'
}

const env = getEnv()

export default urls[env]



// WEBPACK FOOTER //
// ./src/App/Root/url.js